'use client';

import styled from 'styled-components';
import { COLORS } from '@/constants';

export const Banner = styled.div<{ $contain?: boolean }>`
  box-sizing: border-box;
  width: 100%;
  height: 300px;
  background: ${COLORS['neutral/200']};
  overflow: hidden;
  border-radius: 8px;

  img {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    object-fit: ${({ $contain }) => ($contain ? 'contain' : 'cover')};
    padding: ${({ $contain }) => ($contain ? '24px' : '0')};
  }

  @media (max-width: 600px) {
    height: 180px;
  }
`;

export const BannerSplit = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: stretch;
  width: 100%;
  height: 300px;
  border-radius: 8px;
  overflow: hidden;

  @media (max-width: 600px) {
    height: 420px;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
  }
`;

export const BannerMedia = styled.div`
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: ${COLORS['neutral/200']};

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const BannerLogoPanel = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  min-height: 0;
  background: ${COLORS['neutral/900']};
  padding: 32px;

  img {
    display: block;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  @media (max-width: 600px) {
    padding: 16px;
  }
`;
